import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/ComparativeTrayUsageSelectors';
import ReportCustomFilterTypes from '../../../../common/redux/actions/types/ReportCustomFilterTypes';

export function ComparativeTrayUsageContainer(props) {
  return (
    <Report
      reportId={ReportDefinitions.COMPARATIVE_TRAY_USAGE_941.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
      customFilterType={ReportCustomFilterTypes.COMPARATIVE_TRAY_USAGE_941}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

ComparativeTrayUsageContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(ComparativeTrayUsageContainer);
